/**
 * Adds a prefix to routes, e.g /content with the prefix /admin would be
 * /admin/content.
 */

const prefixRoutes = (routes: { map: Function }, prefix: string) => {
  return routes.map((r: { path: string }) => ({
    ...r,
    path: prefix + r.path
  }));
};

export default prefixRoutes;
